module.exports = __webpack_public_path__ + "img/upload-success.797b09e8.svg";